import React from 'react';
import './HoverPopover.css';

const HoverPopover = ({ children, popover, position = 'bottom', className = '' }) => {
  return (
    <div className={`hover-popover ${className}`}>
      {children}
      <div className={`hover-popover-content popover-${position}`}>
        {popover}
      </div>
    </div>
  );
};

export default HoverPopover;
